<script>
	import { prefix, maxDemoWidth } from '../stores.js';

	export let iconName;
	export let iconClass = '';

	$: iconClasses = $prefix + '-icon ' + $prefix + '-icon--' + iconClass;
</script>

<svg class="{$maxDemoWidth ? $prefix + '-max-demo-width ' + iconClasses : iconClasses}">
    <use xlink:href="#x818973c5df76821320be3bb174285ef4-{iconName}" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
</svg>

<style type="text/scss">
    @import './sass/vars';

	.#{$prefix}-icon {
		flex-shrink: 0;
		height: 48px;
		width: 48px; 
		margin-right: 4px;
		stroke: $primary-light;

		&--tooltip {
      		height: 45px;  // 3.7531276063386154
			margin-right: 22px; // 1.8348623853211008
      		width: 45px;
		}

		&--inline {
			height: 2rem;
			width: 2rem;
		}

		&--list {
			height: 4.753961634695579vw;
			width:  4.753961634695579vw;
			margin-right: 1.3344453711426187vw;
			margin-bottom: 0.5vw;
			&.#{$prefix}-max-demo-width {
				@media only screen and (min-width: $breakpoint-xlarge) {
					height: 57px; // 4.753961634695579
					width:  57px;
					margin-right: 1rem;
					margin-bottom: 0.5rem;
				}
			}
		}

		&--arrow {
			width: 18px;
			height: 16px;
			margin: 0;
			&-small {
				width: 11px;
				height: 10px;
			}

			&-left-small {
				width: 16px;
				height: 16px;
			}
		}

		&--fill {
			position: relative;
			width: 100%;
			height: 100%;
		}

	 	&--black {
			stroke: black;
			// height: 40px; 
			// width:  40px;
		}

	 	// &--modal, &--flyout {
		// 	height: 85px; 
		// 	width:  85px;
		// }

		&--modal-light, &--flyout-light {
			stroke: white;
		}

		&--modal-highlight {
			stroke: $secondary;
			margin-right: 0 !important;
			height: 3.571428571428571vw; 
			width:  3.571428571428571vw;
			&.#{$prefix}-max-demo-width {
				@media only screen and (min-width: $breakpoint-xlarge) {
					height: 42.5px;
					width:  42.5px;
				}
			}

		}
	}

	:global(.#{$prefix}-addon-icon) {
		display: inline-flex;
		&:before {
			width: 1.6680567139282734vw;
			height: 1.6680567139282734vw;
			margin-right: 0.6672226855713094vw;
			display: inline-block;
			position: relative;
			content: '';
			background-repeat: no-repeat;
			background-position: center center;
		}

		&.addon-icon {
			&--clock:before {
				background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS41IDEuNSkiIHN0cm9rZT0iIzM5NEQ4MCIgc3Ryb2tlLXdpZHRoPSIxLjUiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48Y2lyY2xlIGN4PSIxMC41IiBjeT0iMTAuNSIgcj0iMTAuNSIvPjxwYXRoIGQ9Ik0xMC41IDEwLjVWNi43NU0xMC41IDEwLjVsNC42ODcgNC42ODgiLz48L2c+PC9zdmc+") no-repeat center center;
				background-size: auto 100%;
			}

		}


		&.#{$prefix}-max-demo-width {

			@media only screen and (min-width: $breakpoint-xlarge) {
				&:before {
					width: 20px;
					height: 20px;
					margin-right: 8px;
				}
			}
		}

	}


</style>
